var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArrowTeal(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 13,
    viewBox: "0 0 15 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.14769 0.105084L0.104438 6.14869C-0.0348131 6.28794 -0.034813 6.51367 0.104438 6.65292L6.14769 12.6963C6.28694 12.8356 6.51266 12.8356 6.65191 12.6963L8.26213 11.0863C8.32899 11.0194 8.36661 10.9289 8.36661 10.8342C8.36661 10.7397 8.32899 10.6489 8.26213 10.5821L5.67109 7.99069L14.1479 7.99069C14.3447 7.99069 14.5045 7.83093 14.5045 7.63409L14.5045 5.16733C14.5045 4.97049 14.3447 4.81074 14.1479 4.81074L5.67127 4.81074L8.26231 2.2197C8.39603 2.08598 8.39603 1.8492 8.26231 1.71548L6.65209 0.105264C6.58523 0.0384023 6.49448 0.000780775 6.39998 0.00078078C6.30548 0.000602447 6.21455 0.038223 6.14769 0.105084Z",
    fill: "#077CA0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowTeal);
export default __webpack_public_path__ + "static/media/arrow_teal.55a638aa8f6a793834da417f1b7af1e7.svg";
export { ForwardRef as ReactComponent };